import styled from "styled-components"

const SiteHeading = styled.div`
    padding: 200px 0 150px;
    color: white;
    @media only screen and (min-width: 768px) {
    padding: 200px 0;
    }
    text-align: center;
`

const SubHeading = styled.span`
    font-size: 32px;
    font-weight: 500;
    line-height: 1.1;
    display: block;
    margin: 10px 0 0;
    @include sans-serif-font;
    @media only screen and (max-width: 400px) {
    font-size: 30px;
    }
`

const H1 = styled.h1`
    font-size: 50px;
    margin-top: 0;
    @media only screen and (min-width: 768px) {
    font-size: 80px;
}
`

export {
    SiteHeading,
    H1,
    SubHeading
}